import { render, staticRenderFns } from "./BFormValidationError.vue?vue&type=template&id=4b4c1ca4&"
import script from "./BFormValidationError.vue?vue&type=script&lang=js&"
export * from "./BFormValidationError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports